import { render, staticRenderFns } from "./AdminTagForm.vue?vue&type=template&id=7e5cc2ce"
import script from "./AdminTagForm.vue?vue&type=script&lang=js"
export * from "./AdminTagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports